import { AccountsStore } from './accounts-store';
import { AccountStore } from './account-store';
import { ActivityLogsSearchStore } from './activity-logs-search-store';
import { AppEventItemModalStore } from './app-event-item-modal-store';
import { CandidateAvailabilityModalStore } from './candidate-availability-modal-store';
import { ContactsStore } from './contacts-store';
import { ContactStore } from './contact-store';
import { DeletePositionStore } from './delete-position-store';
import { EditOpportunityFulfillmentStore } from './edit-opportunity-fulfillment-store';
import { EditOpportunityTalentTabStore } from './edit-opportunity-talent-tab-store';
import { EditPositionStore } from './edit-position-store';
import { EditSavedOpportunityFilterStore } from './edit-saved-opportunity-filter-store';
import { EventsStore } from './events-store';
import { FormAccountConfidentialStore } from './form-account-confidential-store';
import { FormAutoCoolingModalStore } from './form-auto-cooling-modal-store';
import { FormOpportunityProfileDetailStore } from './form-opportunity-profile-detail-store';
import { FormOpportunityProfileNextStepsDescriptionStore } from './form-opportunity-profile-next-steps-description-store';
import { OpportunitiesStore } from './opportunities-store';
import { OpportunityCandidatesStore } from './opportunity-candidates-store';
import { OpportunityEngagementsStore } from './opportunity-engagements-store';
import { OpportunityPositionsStore } from './opportunity-positions-store';
import { OpportunityStore } from './opportunity-store';
import { PreloadedAppErrorsStore } from './preloaded-app-errors-store';
import { PreloadedBarredLocationsStore } from './preloaded-barred-locations-store';
import { PreloadedFeatureFlagsStore } from './preloaded-feature-flags-store';
import { PreloadedGroupsStore } from './preloaded-groups-store';
import { PreloadedLanguagesStore } from './preloaded-languages-store';
import { PreloadedUsersStore } from './preloaded-users-store';
import { PreloadedUserStore } from './preloaded-user-store';
import { TalentWarningModalStore } from './talent-warning-modal-store';
import { UserOpportunityFiltersStore } from './user-opportunity-filters-store';

export const stores = {
  ACCOUNT: AccountStore,
  ACCOUNTS: AccountsStore,
  ACTIVITY_LOGS_SEARCHABLES: ActivityLogsSearchStore,
  APP_ERRORS: PreloadedAppErrorsStore,
  APP_FORM_EVENT_ITEM_STORE: AppEventItemModalStore,
  BARRED_LOCATIONS: PreloadedBarredLocationsStore,
  CANDIDATE_AVAILABILITY_MODAL: CandidateAvailabilityModalStore,
  CONTACT: ContactStore,
  CONTACTS: ContactsStore,
  DELETE_POSITION: DeletePositionStore,
  EDIT_AUTO_COOLING_MODAL: FormAutoCoolingModalStore,
  EDIT_OPPORTUNITY_FULFILLMENT: EditOpportunityFulfillmentStore,
  EDIT_OPPORTUNITY_TALENT_TAB: EditOpportunityTalentTabStore,
  EDIT_POSITION: EditPositionStore,
  EDIT_SAVED_OPPORTUNITY_FILTERS: EditSavedOpportunityFilterStore,
  EVENTS: EventsStore,
  FEATURE_FLAGS: PreloadedFeatureFlagsStore,
  FORM_ACCOUNT_CONFIDENTIAL: FormAccountConfidentialStore,
  FORM_OPP_NEXT_STEP_DESCRIPTION:
    FormOpportunityProfileNextStepsDescriptionStore,
  FORM_OPP_PROFILE_DETAIL: FormOpportunityProfileDetailStore,
  GROUPS: PreloadedGroupsStore,
  LANGUAGES: PreloadedLanguagesStore,
  OPPORTUNITIES: OpportunitiesStore,
  OPPORTUNITY_CANDIDATES: OpportunityCandidatesStore,
  OPPORTUNITY_ENGAGEMENTS: OpportunityEngagementsStore,
  OPPORTUNITY_POSITIONS: OpportunityPositionsStore,
  OPPORTUNITY: OpportunityStore,
  TALENT_WARNING_MODAL: TalentWarningModalStore,
  USER_OPPORTUNITY_FILTERS: UserOpportunityFiltersStore,
  USER: PreloadedUserStore,
  USERS: PreloadedUsersStore,
};
